import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function DetectionTypesPage() {
  const columns = [
    {
      title: 'Detection Type',
      dataIndex: 'detection_type_desc',
      key: 'detection_type_desc',
    }
  ];

  const formFields = [
    {
      name: 'detection_type_id',
      label: 'Detection ID',
      type: 'textarea',
      placeholder: 'Detection ID',
      disabled: true,
      //rules: [{ required: false, message: 'Must Enter the Model Name!'  }]
    },
    {
      name: 'detection_type_desc',
      label: 'Detection Name',
      type: 'textarea',
      placeholder: 'Detection Name',
      rules: [{ required: true, message: 'Must Enter the Model Name!' }]
    }
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/detectiontypes"
        readEndpoint="read/detectiontypes"
        editEndpoint="update/detectiontypes"
        deleteEndpoint="delete/detectiontypes"
        columns={columns}
        formFields={formFields}
        title="Detection Types"
      />
    </div>
  );
}